import { Box, styled, css, CircularProgress } from '@mui/material';
import { theme } from 'assets/themes/zizzi';
import ZizziPoint from 'assets/icons/ZizziPoint';
import { Color } from 'models';

const position = css`
  left: 50%;
  margin: 0;
  position: absolute;
  top: 50%;
  transform: translate(-50%, -50%);
`;

export const StyledBox = styled(Box)`
  ${position};
`;

interface SpinnerProps {
  type: Color;
}

interface Colors {
  dark: string;
  light: string;
}

const color: Colors = {
  dark: theme.palette.primary.main,
  light: theme.palette.white,
};

export const Spinner = styled(CircularProgress)<SpinnerProps>`
  color: ${({ type }) => color[type]};
`;

export const StyledLogo = styled(ZizziPoint)`
  ${position};
  width: 55px;
  height: 55px;
  top: 37px;
`;
